import { Injectable } from '@angular/core';
import { TitleStrategy } from '@angular/router';

/**
 * Route titles are applied by SeoService together with description, canonical,
 * hreflang and structured data. Prevent the default strategy from overwriting
 * the localized title with the static French route fallback after navigation.
 */
@Injectable()
export class SeoTitleStrategy extends TitleStrategy {
  override updateTitle(): void {
    // Intentionally centralized in SeoService.
  }
}
